import { selectAtom } from "jotai/utils";
import { questionnaireReducerAtom } from "./questionnaireReducerAtom";
import { shallowEqual } from "../../../utils/shallowEqual";
import type { AddressModes } from "../types";

/**
 * Atom that selects address modes from the questionnaire state.
 *
 * This atom uses shallow equality comparison to only trigger re-renders
 * when the addressModes object actually changes. Address modes track
 * whether address lookup questions are in manual or automatic mode.
 */
export const questionnaireAddressModesAtom = selectAtom(
  questionnaireReducerAtom,
  (state): AddressModes | undefined => state.addressModes,
  (a, b) => {
    if (a === undefined && b === undefined) return true;
    if (a === undefined || b === undefined) return false;
    return shallowEqual(a, b);
  },
);
